// src/components/HowItWorks.js
import React from 'react';
import './HowItWorks.css';

const HowItWorks = () => {
  const steps = [
    {
      number: '01',
      title: 'Understand your needs',
      description: 'We review your profile, income, and relevant documents to understand your eligibility.'
    },
    {
      number: '02',
      title: 'Plan repayment clearly',
      description: 'Repayment options are structured around your financial capacity, not fixed templates.'
    },
    {
      number: '03',
      title: 'Disburse without friction',
      description: 'Clear terms, no hidden conditions, and fast disbursal once everything checks out.'
    },
    {
      number: '04',
      title: 'Support beyond approval',
      description: 'Repayment visibility, ongoing support, and real humans when things change.'
    }
  ];

  return (
    <section className="approach-ops">
      <div className="approach-container">
        <div className="approach-header">
          <span className="approach-tag">HOW IT WORKS</span>
          <h2>Built like a lending operation,<br />not a marketing funnel</h2>
          <p>
            Every step is designed to reduce uncertainty for borrowers —
            before money moves, not after.
          </p>
        </div>

        <div className="approach-grid">
          <div className="approach-steps">
            {steps.map((step, index) => (
              <div key={index} className="step">
                <span className="step-num">{step.number}</span>
                <div>
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="approach-image">
            <div className="image-main">
              <img 
                src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf" 
                alt="Customer discussing loan options" 
              />
              <div className="floating-stats">
                <div className="stat-badge">
                  <strong>Fastest</strong>
                  <span>Approval</span>
                </div>
                <div className="stat-badge">
                  <strong>100%</strong>
                  <span>Digital</span>
                </div>
                <div className="stat-badge">
                  <strong>0</strong>
                  <span>Hidden Fees</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
